(() => {
  const boot = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const $ = (s) => root.querySelector(s);
    const $$ = (s) => [...root.querySelectorAll(s)];
    const strings = JSON.parse($('[data-strings]').textContent);
    let lastFocus;
    const sticky = $('[data-sticky]');
    let primaryVisible = true;
    const refreshSticky = () => {
      sticky.hidden = !!$('[data-access-required][hidden]') || primaryVisible || !!$('dialog[open]') || ['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement?.tagName);
    };
    const open = (dialog) => {
      lastFocus = document.activeElement;
      dialog.showModal();
      refreshSticky();
    };
    $$('dialog').forEach((dialog) => {
      dialog.querySelector('[data-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (e) => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
      dialog.addEventListener('close', () => { lastFocus?.focus(); refreshSticky(); });
    });
    $('[data-open-inquiry]').addEventListener('click', () => open($('[data-inquiry]')));
    $('[data-open-guide]')?.addEventListener('click', () => open($('[data-guide]')));
    if ($('[data-inquiry-success]') || $('[data-inquiry] .errors')) open($('[data-inquiry]'));
    $('[data-condition-link]')?.addEventListener('click', () => { const d = root.querySelector('.odp-details[id]'); if (d) d.open = true; });
    const gallery = $('[data-gallery]');
    const slides = $$('[data-slide]');
    let current = 0;
    const setSlide = (index) => {
      current = (index + slides.length) % slides.length;
      gallery.scrollTo({ left: current * gallery.clientWidth, behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
    };
    $('[data-gallery-prev]').addEventListener('click', () => setSlide(current - 1));
    $('[data-gallery-next]').addEventListener('click', () => setSlide(current + 1));
    $$('[data-thumbnail]').forEach((b) => b.addEventListener('click', () => setSlide(Number(b.dataset.thumbnail))));
    gallery.addEventListener('scroll', () => {
      current = Math.round(gallery.scrollLeft / gallery.clientWidth);
      $('[data-gallery-count]').textContent = current + 1;
      $$('[data-thumbnail]').forEach((b, i) => b.setAttribute('aria-current', i === current ? 'true' : 'false'));
    }, { passive: true });
    gallery.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); setSlide(current + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); setSlide(current - 1); } });
    const images = JSON.parse($('[data-gallery-images]').textContent);
    let zoomIndex = 0;
    const renderZoom = () => {
      const item = images[zoomIndex];
      $('[data-zoom-image]').src = item.src;
      $('[data-zoom-image]').alt = item.alt;
      $('[data-zoom-count]').textContent = (zoomIndex + 1) + ' / ' + images.length;
      $('.odp-zoom-stage').classList.remove('is-zoomed');
    };
    $$('[data-zoom-index]').forEach((b) => b.addEventListener('click', () => { zoomIndex = images.findIndex((i) => i.index === Number(b.dataset.zoomIndex)); renderZoom(); open($('[data-zoom]')); }));
    $('[data-zoom-prev]').addEventListener('click', () => { zoomIndex = (zoomIndex - 1 + images.length) % images.length; renderZoom(); });
    $('[data-zoom-next]').addEventListener('click', () => { zoomIndex = (zoomIndex + 1) % images.length; renderZoom(); });
    $('[data-zoom-toggle]').addEventListener('click', () => $('.odp-zoom-stage').classList.toggle('is-zoomed'));
    let touchStart = 0;
    $('.odp-zoom-stage').addEventListener('touchstart', (e) => { if (e.touches.length === 1) touchStart = e.touches[0].clientX; }, { passive: true });
    $('.odp-zoom-stage').addEventListener('touchend', (e) => { if ($('.odp-zoom-stage').classList.contains('is-zoomed')) return; const diff = e.changedTouches[0].clientX - touchStart; if (Math.abs(diff) > 60) { zoomIndex = (zoomIndex + (diff < 0 ? 1 : -1) + images.length) % images.length; renderZoom(); } }, { passive: true });
    const product = JSON.parse($('[data-save-product]').textContent);
    const key = 'od_saved_pieces_v1';
    const read = () => { try { const data = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(data) ? data.filter(p => p && p.id && typeof p.url === 'string') : []; } catch { return []; } };
    const updateSaved = () => { const saved = read().some(p => p.id === product.id); $('[data-save]').setAttribute('aria-pressed', String(saved)); $('[data-save-text]').textContent = saved ? root.dataset.savedLabel : root.dataset.saveLabel; };
    const saveItems = (items) => { try { localStorage.setItem(key, JSON.stringify(items)); return true; } catch { $('[data-save-status]').textContent = strings.storage_error; return false; } };
    const renderSaved = () => {
      const list = $('[data-saved-list]'); list.replaceChildren();
      const items = read();
      if (!items.length) { const p = document.createElement('p'); p.textContent = strings.empty; list.append(p); }
      items.forEach((item) => {
        const row = document.createElement('div'); row.className = 'odp-saved-item';
        const img = document.createElement('img'); img.src = item.image; img.alt = item.title; img.loading = 'lazy';
        const info = document.createElement('div'); const a = document.createElement('a'); a.href = item.url; a.textContent = item.title;
        const price = document.createElement('span'); price.textContent = item.price;
        const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = strings.remove; remove.addEventListener('click', () => { saveItems(read().filter(p => p.id !== item.id)); updateSaved(); renderSaved(); });
        info.append(a, price, remove); row.append(img, info); list.append(row);
      });
    };
    $('[data-save]').addEventListener('click', () => { const items = read(); const saved = items.some(p => p.id === product.id); if (saveItems(saved ? items.filter(p => p.id !== product.id) : [product, ...items])) { updateSaved(); $('[data-save-status]').textContent = saved ? strings.removed : strings.saved; } });
    $('[data-open-saved]').addEventListener('click', () => { renderSaved(); open($('[data-saved-dialog]')); });
    updateSaved();
    window.addEventListener('storage', updateSaved);
    const gate = $('[data-access-gate]');
    if (gate) {
      const unlock = () => { gate.hidden = true; $('[data-access-required]').hidden = false; refreshSticky(); };
      try { if (sessionStorage.getItem('od_drop_unlocked') === 'true') unlock(); } catch {}
      $('[data-unlock]').addEventListener('click', () => {
        if ($('[data-access-input]').value.trim().toLowerCase() === 'dunnvip') { try { sessionStorage.setItem('od_drop_unlocked','true'); } catch {} unlock(); }
        else $('[data-access-error]').hidden = false;
      });
      $('[data-access-input]').addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); $('[data-unlock]').click(); } });
    }
    const form = $('.odp-product-form');
    if (form) form.addEventListener('submit', async (e) => {
      e.preventDefault(); const button = $('[data-add]'); if (button.disabled) return;
      const error = $('[data-cart-error]'); error.hidden = true; button.disabled = true; button.textContent = root.dataset.addingLabel;
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = new FormData(form);
      if (cart?.getSectionsToRender) { body.append('sections', cart.getSectionsToRender().map(s => s.id).join(',')); body.append('sections_url', location.pathname); cart.setActiveElement?.(document.activeElement); }
      try {
        const response = await fetch(root.dataset.addUrl + '.js', { method: 'POST', body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || root.dataset.errorLabel);
        if (cart?.renderContents) { cart.classList.remove('is-empty'); cart.renderContents(data); } else { location.assign(root.dataset.cartUrl); }
      } catch (err) { error.textContent = err.message || root.dataset.errorLabel; error.hidden = false; } finally { button.disabled = false; button.textContent = root.dataset.addLabel; }
    });
    $('[data-sticky-add]')?.addEventListener('click', () => form?.requestSubmit());
    new IntersectionObserver(([entry]) => { primaryVisible = entry.isIntersecting; refreshSticky(); }, { threshold: 0 }).observe($('[data-primary-action]'));
    document.addEventListener('focusin', refreshSticky);
    document.addEventListener('focusout', () => requestAnimationFrame(refreshSticky));
  };
  document.querySelectorAll('[data-od-product]').forEach(boot);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-od-product]').forEach(boot));
})();
